import "core-js/stable";
import "regenerator-runtime/runtime";
import "../scss/style.scss";

import barba from "@barba/core/dist/barba";
import select from 'dom-select'
import { classy as cl } from "./helpers/classy";
import { scrollLock, scrollUnLock } from "./helpers/scrollLock";
import Spoilers from "./helpers/spoilers";
import videoResize from "./helpers/videoResize";
import scrollAnimatron from "./helpers/scrollAnimatron";
import Cookies from 'js-cookie'

import maps from "./helpers/maps";
import mapsXmas from "./helpers/mapsXmas";
import axios from "./helpers/axios";
import App from "../js/landingPage/index.svelte";
import SliderPageApp from "../js/SliderPage/index.svelte";
import { throttle } from "lodash-es";
import Swiper from 'swiper/bundle';
// import * as SlimSelect from 'slim-select'
import Player from "@vimeo/player";
import SmoothScroll from "smooth-scroll";
import LazyLoad from "vanilla-lazyload";
import YouTubePlayer from "youtube-player";
import autocomplete from "autocomplete.js";
import iframeResize from "iframe-resizer/js/iframeResizer";
import "@lottiefiles/lottie-player";
import viewportUnitsBuggyfill from "viewport-units-buggyfill";
import { mount } from "svelte";

(function (doc, win) {
  viewportUnitsBuggyfill.init();
  window.openModal = false;
  window.dataLayer = window.dataLayer || [];
  const app = {};

  const accordionBodyBlock = () => {
    const acc = document.getElementsByClassName(
      "accordion-body-block-item-heading"
    );
    let i;

    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", function () {
        this.parentElement.classList.toggle(
          "accordion-body-block-expanded-item"
        );
        const panel = this.nextElementSibling;
        panel.classList.toggle("mb-4");

        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + "px";
        }
      });
    }
  };

  function scLock(target) {
    scrollLock(target, (w) => {
      const header = select(".header");
      if (header) {
        header.style.paddingRight = w + "px";
      }
    });
  }

  const lottiePlayer = (container) => {
  const lottiePlayerElements = container.querySelectorAll("lottie-player");

  if (lottiePlayerElements.length > 0) {
    //const scriptSrc = "https://unpkg.com/@lottiefiles/lottie-player@0.4.0/dist/lottie-player.js";
    //const existingScriptTag = document.querySelector(`script[src="${scriptSrc}"]`);

    const initializeLottiePlayers = () => {
      lottiePlayerElements.forEach(function (player) {
        const lottieJson = player.getAttribute("data-lottie-json");
        player.load(lottieJson);
      });
    };

    initializeLottiePlayers();

    // if (!existingScriptTag) {
    //   const script = document.createElement("script");
    //   script.src = scriptSrc;
    //   script.async = true;
    //   script.defer = true;
    //   document.head.appendChild(script);

    //   script.onload = initializeLottiePlayers;
    // } else {
    //  initializeLottiePlayers();
    //}
    }
  };

  

const initSummerSearcher = (parent)=>{
  if( document.getElementById('check-locations') ){
  
    
  var summerMap = {
    1: { x: [12], y: ['H', 'I', 'J'] }, // Allows for 12H, 12I, 12J
    2: { x: [3], y: ['P', 'Q'] }, // Allows for 3P, 3Q
    3: { x: [4, 5], y: ['G', 'H'] }, // Allows for 4G, 4H, 5G, 5H
    4: { x: [3], y: ['M'] }, // Allows for 3M
    5: { x: [10, 11], y: ['N'] }, // Allows for 10N, 11N
    6: { x: [5], y: ['F'] } // Allows for 5F
  };
  
  document.querySelectorAll('.input-number').forEach(function(input) {
    input.addEventListener('change', function() {
      var limit = this.getAttribute('max');
      var val = parseInt(this.value);
      if (val > limit) {
        this.value = limit;
      }
    });
  });



  document.getElementById('check-locations').addEventListener('click', function() {
    var error = false;
    var errorMessage = document.querySelector('.summer-error-messsage');
    var successMessage = document.querySelector('.summer-success-messsage');


    document.querySelectorAll('.input-number').forEach(function(input) {
      var val = parseInt(input.value);
      var id = input.getAttribute('data-id');
      if (val != '' && val !== undefined && Number.isInteger(val)) {
        if (!summerMap[id]['x'].includes(val)) {
          input.classList.add('error');
          error = true;
        } else {
          input.classList.remove('error');
        }
      } else {
        input.classList.add('error');
        error = true;
      }
    });

    document.querySelectorAll('.input-text').forEach(function(input) {
      var val = input.value;
      var id = input.getAttribute('data-id');
      if (val != '' && val !== undefined) {
        if (!summerMap[id]['y'].includes(val.toUpperCase())) {
          input.classList.add('error');
          error = true;
        } else {
          input.classList.remove('error');
        }
      } else {
        input.classList.add('error');
        error = true;
      }
    });

    if (error) {
      errorMessage.classList.remove('d-none');
      successMessage.classList.add('d-none');
    } else {
      errorMessage.classList.add('d-none');
      successMessage.classList.add('d-block');
      document.querySelectorAll('.form-one-col').forEach(function(element) {
        element.classList.add('d-block');
      });
    }
  });


  
    /*Size is  set in pixels... supports being written as: '250px' */
  var magnifierSize = 250;
  
  /*How many times magnification of image on page.*/
  var magnification = 1.7;
  
  function magnifier() {
    this.magnifyImg = function (ptr, magnification, magnifierSize) {
      let pointer;
      if (typeof ptr === "string") {
        pointer = document.querySelector(ptr);
      } else if (typeof ptr === "object" && ptr instanceof Element) {
        pointer = ptr;
      }
  
      if (!pointer || pointer.tagName !== "IMG") {
        alert("Object must be image.");
        return false;
      }
  
      magnification = Number(magnification);
  
      pointer.addEventListener("mouseenter", function () {
        const magnifierEl = document.querySelector(".magnify");
        this.style.cursor = "none";
        magnifierEl.style.display = "block";
  
        const width = this.offsetWidth;
        const height = this.offsetHeight;
        const src = this.src;
        const rect = this.getBoundingClientRect();
        const imagePos = {
          left: rect.left + window.scrollX,
          top: rect.top + window.scrollY,
        };
        const rightSide = imagePos.left + width;
        const bottomSide = imagePos.top + height;
  
        // Handle magnifier size
        if (typeof magnifierSize === "number") {
          magnifierSize = `${magnifierSize}px`;
        } else if (magnifierSize === undefined) {
          magnifierSize = "150px";
        }
  
        magnifierEl.style.width = magnifierSize;
        magnifierEl.style.height = magnifierSize;
        magnifierEl.style.backgroundSize = `${width * magnification}px ${height * magnification}px`;
        magnifierEl.style.backgroundImage = `url("${src}")`;
  
        const magnifierWidth = parseFloat(getComputedStyle(magnifierEl).width);
        const magnifyOffset = magnifierWidth / 2;
  
        const handleMouseMove = (e) => {
          const pageX = e.pageX;
          const pageY = e.pageY;
  
          if (
            pageX < imagePos.left - magnifyOffset / 6 ||
            pageX > rightSide + magnifyOffset / 6 ||
            pageY < imagePos.top - magnifyOffset / 6 ||
            pageY > bottomSide + magnifyOffset / 6
          ) {
            magnifierEl.style.display = "none";
            document.removeEventListener("mousemove", handleMouseMove);
          } else {
            const bgX = -((pageX - imagePos.left) * magnification - magnifyOffset);
            const bgY = -((pageY - imagePos.top) * magnification - magnifyOffset);
            magnifierEl.style.left = `${pageX - magnifyOffset}px`;
            magnifierEl.style.top = `${pageY - magnifyOffset}px`;
            magnifierEl.style.backgroundPosition = `${bgX}px ${bgY}px`;
          }
        };
  
        document.addEventListener("mousemove", handleMouseMove);
      });
  
      pointer.addEventListener("mouseleave", function () {});
    };
  
    this.init = function () {
      const magnifierEl = document.createElement("div");
      magnifierEl.className = "magnify";
      magnifierEl.style.display = "none";
      magnifierEl.style.position = "absolute";
      magnifierEl.style.pointerEvents = "none";
      document.body.insertAdjacentElement("afterbegin", magnifierEl);
    };
  
    this.init();
    return this;
  }
  
  var magnify = new magnifier();
  magnify.magnifyImg('.beach-img > img', magnification, magnifierSize);
}
}

  const youtubeVideoModal = () => {
    const modals = document.querySelectorAll("[data-yt-modal]");
    const body = document.querySelector("body");
    body.style.overflow = "auto";

    const header = document.querySelector("header");
    header.style.zIndex = null;

    const changeIframeSrc = function (iframe, src) {
      const frame = iframe.cloneNode();
      frame.src = src;
      iframe.parentNode.replaceChild(frame, iframe);
    };

    modals.forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        const iframe = document.getElementById("youtubeVideo");
        changeIframeSrc(
          iframe,
          `https://www.youtube.com/embed/${trigger.dataset.ytModal}?autoplay=1&rel=0`
        );
        const modal = document.getElementById("yt-modal");
        modal.classList.add("open");
        body.style.overflow = "hidden";
        header.style.zIndex = 0;
        header.classList.remove("show");
        const exits = modal.querySelectorAll(".yt-modal-exit");
        exits.forEach(function (exit) {
          exit.addEventListener("click", function (event) {
            event.preventDefault();
            const iframe = document.getElementById("youtubeVideo");
            changeIframeSrc(iframe, "");
            modal.classList.remove("open");
            // Enable scroll
            body.style.overflow = "auto";
            header.style.zIndex = null;
          });
        });
      });
    });
  };

  const initSliderPageSvelteApp = () => {
    const el = document.getElementById("svelte-sliderPage");
    const body = document.querySelector("body");
    body.style.overflow = "auto";
    if (el) {
      body.style.overflow = "hidden";
      const dataset = Object.assign({}, el.dataset);
      // console.log(el, dataset.slides, SliderPageApp,'SliderPageApp')
      mount(SliderPageApp, {target: el, props: {
        slides: dataset.slides,
      }})
      //console.log(l ,'l ')
    }
  };
  const tabsBlock = () => {
    const tabs = document.querySelectorAll("[data-tab-id]");
    const panels = document.querySelectorAll("[data-panel-id]");

    tabs.forEach((el) => {
      el.addEventListener("click", () => {
        el.classList.add("active");
        panels.forEach((el2) => {
          if (el2.dataset.blockId === el.dataset.blockId) {
            if (el2.dataset.panelId === el.dataset.tabId) {
              el2.style.display = "block";
              el2.parentElement.style.backgroundColor = el.dataset.tabColor;
              const tab = document.querySelector(
                `[data-tab-id="${el2.dataset.panelId}"]`
              );
              tab.classList.add("active");
            } else {
              el2.style.display = "none";
              const tab = document.querySelector(
                `[data-tab-id="${el2.dataset.panelId}"]`
              );
              tab.classList.remove("active");
            }
          }
        });
      });
    });
  };
  const initLandingPageSvelteApp = () => {
    if (document.getElementById("svelte-landingPage")) {
      const el = document.getElementById("svelte-landingPage");
      const dataset = Object.assign({}, el.dataset);
      mount(App,{
        target: el,
        props: {
          defaultImageUrl: dataset.defaultImageUrl,
          apiUrl: dataset.apiUrl,
        },
      });
    }
  };
  initLandingPageSvelteApp();

  function scUnlock() {
    scrollUnLock(() => {
      const header = select(".header");
      if (header) {
        header.style.paddingRight = "";
      }
    });
  }

  const nav = function () {
    const header = select(".header");
    app.navSpoilers = new Spoilers(header);
    setModals(header, null, () => {
      app.navSpoilers.closeAll();
    });
    setTabs(header);
    setSearchFields(header, true);

    const headerClose = select(".header-close", header);
    if (headerClose) {
      headerClose.addEventListener("click", () => {
        window.modals.forEach((m) => m.close());
      });
    }

    // const burgers = select.all('.burger');
    // const nav = select('.nav', header);
    //
    // function resetRight() {
    //   nav.style.cssText = ''
    //   header.style.right = ''
    // }
    //
    // function lock() {
    //   window.openModal = header;
    //   scrollLock(header, w => {
    //     nav.style.cssText = `right: ${w}px`
    //     header.style.right = `${w}px`
    //   });
    // }
    //
    // function unlock() {
    //   window.openModal = false;
    //   scrollUnLock(() => { resetRight() })
    // }
    //
    // burgers.forEach(burger => {
    //   burger.addEventListener('click', function () {
    //     if (burger.classList.contains('open')) {
    //       unlock()
    //     } else {
    //       lock()
    //     }
    //     cl(header).toCl('open');
    //     cl(burgers).toCls('open');
    //   })
    // })
    //
    // this.close = function () {
    //   cl(header).rmCl('open');
    //   cl(burgers).rmCls('open');
    //   cl(nav).rmCl('sub-open')
    //   unlock()
    // }

    let lastScrollTop = 0;
    let fixed = false;
    let visible = false;
    const fixedFrom = 400;
    const visibleFrom = 600;

    this.scroll = function () {
      const st = window.pageYOffset || document.documentElement.scrollTop;
      const mobNav = document.getElementById("nav-mobile");
      if (st > fixedFrom && !fixed) {
        cl(header).addCl("is-fixed");
        fixed = true;
      } else if (st <= fixedFrom && fixed) {
        cl(header).rmCl("is-fixed");
        fixed = false;
      }

      if (fixed && st > visibleFrom) {
        if (st > lastScrollTop && visible) {
          cl(header).rmCl("show");
          visible = false;
        } else if (st <= lastScrollTop && !visible) {
          cl(header).addCl("show");
          visible = true;
        }
      } else if (st <= visibleFrom && visible) {
        cl(header).rmCl("show");
        visible = false;
      }

      lastScrollTop = st <= 0 ? 0 : st;
    };
  };

  function activeNav() {
    const firstSegment = location.pathname.split("/")[1];
    const lastSegment = location.pathname.split("/").pop();
    select.all(".header a, .nav a").forEach(function (nav) {
      const linkSegments = nav.pathname.split("/");
      const linkFirstSegment =
        linkSegments.length > 1 && linkSegments[1] !== ""
          ? linkSegments[1]
          : false;
      const linkSecondSegment =
        linkSegments.length > 2 && linkSegments[2] !== ""
          ? linkSegments[2]
          : false;

      if (linkSecondSegment && linkSecondSegment === lastSegment)
        cl(nav).addCl("active");
      else if (
        linkFirstSegment &&
        !linkSecondSegment &&
        linkFirstSegment === firstSegment
      )
        cl(nav).addCl("active");
      else cl(nav).rmCl("active");
    });

    // STEVE - MOBILE SEARCH KEYBOARD *****
    const element = document.querySelector("#nav-search");
    element.addEventListener("focus", function () {
      var container = document.querySelector("#nav-mobile .nav-inner");
      var offset = 50;
      var elementPosition = element.getBoundingClientRect().top;
      var offsetPosition = offset + elementPosition - 120;
      if (container) {
        container.scrollTo({
          top: offsetPosition,
          behavior: "smooth",
        });
      }

      //smooth(mobileSearch, 50, 300)
    });
  }

  function inputs(parent = document) {
    select
      .all(".input, .fui-i .fui-input, .fui-i .fui-select", parent)
      .forEach((input) => {
        if (input.value !== "") {
          input.classList.add("filled");
          input.parentNode.classList.add("filled");
        }
        input.addEventListener("focus", function () {
          input.classList.add("filled");
          input.parentNode.classList.add("filled");
        });
        input.addEventListener("blur", function () {
          if (input.value === "") {
            input.classList.remove("filled");
            input.parentNode.classList.remove("filled");
          }
        });
        input.addEventListener("change", function () {
          input.classList.add("filled");
          input.parentNode.classList.add("filled");
        });

        //need to remove passing from manually hidden fields.
        let hiddenContainer =
          input.parentNode.parentNode.parentNode.classList.contains(
            "hidden-field-row"
          );
        if (hiddenContainer) {
          input.parentNode.parentNode.parentNode.parentNode.classList.add(
            "mb-0"
          );
        }
      });

    //TABLE add new fields. Populate heading with previous value
    let $fields = document.querySelectorAll(".fui-type-table");
    // For each field, bind on the `append` event
    $fields.forEach(($field) => {
      $field.addEventListener("append", (e) => {
        let $newrow = e.detail.row;
        let $form = e.detail.form;
        let $heading = $form.querySelector;

        $heading = $field.querySelector("div").closest(".fui-type-table")
          .dataset.headinglabel;
        if ($heading !== undefined) {
          $newrow.childNodes[0].querySelector('input[type="hidden"]').value =
            $heading;
          $newrow.childNodes[0].innerHTML += $heading;
        }
      });
    });
  }

  function addFormieScript(parent) {
    const forms = select.all(".fui-i", parent);
    forms.forEach((formWrap) => {
      const parenNode = formWrap.parentElement;
      select.all("script", parenNode).forEach((s) => {
        const newScript = doc.createElement("script");
        newScript.type = "text/javascript";
        if (s.innerHTML.length) {
          const inlineScript = document.createTextNode(s.innerHTML);
          newScript.appendChild(inlineScript);
        }
        if (s.src) {
          newScript.setAttribute("defer", "");
          newScript.src = s.src;
          newScript.onload = () => {
            //window.Formie.initForms();
          };
        }
        s.remove();
        parenNode.appendChild(newScript);
        // console.log(newScript)
      });
    });
  }

  function smooth(el, offset, speed) {
    if (el) {
      const scroll = new SmoothScroll();
      scroll.animateScroll(el, false, {
        offset: offset || 200,
        updateURL: false,
        speed: speed || 600,
        durationMax: speed || 600,
      });
    }
  }

  function setSmooth(parent) {
    select.all(".smooth-scroll", parent).forEach((anchor) => {
      anchor.addEventListener("click", (ev) => {
        ev.preventDefault();
        ev.stopPropagation();
        if (anchor.dataset.hasOwnProperty("window")) {
          smooth(window.innerHeight, 0, 1000);
        } else {
          const target = select(anchor.hash);
          if (target) smooth(target, 40, 1000);
        }
      });
    });
  }

  function setHoverElements(parent) {
    select.all(".hover-elements-wrap", parent).forEach((section) => {
      const targets = [];
      select.all("[data-hover-target]", section).forEach((trigger) => {
        const targetNodes = select.all(
          '[data-hover-el="' + trigger.dataset.hoverTarget + '"]',
          section
        );
        if (targetNodes.length) {
          targets.push(targetNodes);
          trigger.addEventListener("mouseover", () => {
            targets.forEach((t) => cl(t).rmCls("active"));
            cl(targetNodes).addCls("active");
          });
        }
      });
    });
  }

  function setTabs(parent) {
    const triggers = select.all("[data-tab]", parent);
    const tabs = select.all(".tab", parent);
    triggers.forEach((tabClick) => {
      tabClick.addEventListener("click", (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        const target = select("#" + tabClick.dataset.tab);
        if (target) {
          cl(triggers).rmCls("active");
          cl(tabs).rmCls("active");
          cl(tabClick).addCl("active");
          cl(target).addCl("active");
        }
      });
    });

    select.all(".tab-select", parent).forEach((s) => {
      s.addEventListener("change", (ev) => {
        const targets = select.all("#" + ev.target.value);
        const targetsTriggers = select.all(
          '[data-tab="' + ev.target.value + '"]'
        );
        if (targets.length) {
          cl(triggers).rmCls("active");
          cl(tabs).rmCls("active");
          cl(targets).addCls("active");
          cl(targetsTriggers).addCls("active");
        }
      });
    });
  }

  app.swipers = [];
  function swipers(parent) {
    app.swipers.forEach((sw) => sw.destroy());
    app.swipers = [];

    select.all(".swiper-regular", parent).forEach((sw) => {
      app.swipers.push(
        new Swiper(sw, {
          speed: 1000,
          pagination: {
            type: "bullets",
            el: select(".swiper-pagination", sw),
          },
        })
      );
    });

    select.all(".section-horizontal-list", parent).forEach((section) => {
      const sw = select(".swiper-container", section);
      app.swipers.push(
        new Swiper(sw, {
          speed: 1000,
          slidesPerView: 1,
          spaceBetween: 20,
          breakpoints: {
            620: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1280: {
              slidesPerView: 4,
            },
          },
          navigation: {
            nextEl: select(".horizontal-swipe-nav .is-right", section),
            prevEl: select(".horizontal-swipe-nav .is-left", section),
          },
        })
      );
    });

    select
      .all(".section-swiper-columns .swiper-container", parent)
      .forEach((sw) => {
        app.swipers.push(
          new Swiper(sw, {
            speed: 1000,
            effect: "fade",
            allowTouchMove: false,
            pagination: {
              el: select.all(".section-swiper-nav", sw),
              type: "bullets",
              clickable: true,
              bulletClass: "text-bullet",
              bulletActiveClass: "active",
              renderBullet: function (index, className) {
                const text = this.slides[index].dataset.navText;
                return `<div class="${className} bullet-${
                  index + 1
                }">${text}</div>`;
              },
            },
            on: {
              transitionStart(sw) {
                cl(sw.el).addCl("transitioning");
              },
              transitionEnd(sw) {
                cl(sw.el).rmCl("transitioning");
              },
            },
          })
        );
      });
    setTimeout(function () {
      app.swipers.forEach((sw) => sw.update());
    }, 200);
  }

  // STEVE NEW FSPR
  function selectSearch(parent) {
    const urlParams = new URLSearchParams(window.location.search);
    const broker = urlParams.get("broker");
    const solution = urlParams.get("solution");

    if (broker !== null || solution !== null) {
      if (solution !== null) {
        var url = "solution/" + solution;
      } else if (broker !== null) {
        var url = "broker/" + broker;
      }

      axios
        .get("/api-twig/fsprsearch/" + url)
        .then(function (data) {
          //console.log('get: '+ data);
          //parse Data
          //var data = JSON.parse(data.data)
          select(".select-broker select", parent).innerHTML =
            data.data[0].option;
          document.querySelector(
            'input[name="fields[recipientsHidden]"]'
          ).value = "pre";
          cl(".select-broker").addCl("greyed-out");
          document.querySelector(
            ":scope .select-broker select"
          ).disabled = true;
          var input = document.createElement("input");
          input.setAttribute("type", "hidden");
          input.setAttribute("name", "fields[selectFSPRBroker]");
          input.setAttribute("value", data.data[0].email);
          document
            .querySelector(":scope .select-broker .fui-field-container")
            .appendChild(input);
        })
        // .then(function () {
        //   new SlimSelect({
        //     select: ".select-broker select",
        //   });
        // });
    } else {
      select.all(".nearest-branch select").forEach((s) => {
        if (!!select(".select-broker select", parent)) {
          cl(".select-broker").addCl("greyed-out");
          document.querySelector(
            ":scope .select-broker select"
          ).disabled = true;

          // new SlimSelect({
          //   select: ".nearest-branch select",
          // });

          s.addEventListener("change", (ev) => {
            const branchId = ev.target.value;
            axios
              .get("/api-twig/fsprsearch/branch/" + branchId)
              .then(function (data) {
                //console.log('get: '+ data);
                select(".select-broker select", parent).innerHTML = data.data;
                cl(".select-broker").rmCls("greyed-out");
                document.querySelector(
                  ":scope .select-broker select"
                ).disabled = false;
              })
              // .then(function () {
              //   new SlimSelect({
              //     select: ".select-broker select",
              //   });
              // });
          });
        }
      });
    }
  }

  function iframeVideos(parent) {
    return select.all(".iframe-video", parent).map((videoWrap) => {
      const videoId = videoWrap.dataset.videoId;
      const videoType = videoWrap.dataset.videoType;
      let pl = null;

      if (videoType === "youtube") {
        const player = YouTubePlayer(videoWrap, { videoId });
        if (player) {
          pl = {
            wrap: videoWrap.parentNode,
            play() {
              player.playVideo();
            },
            pause() {
              player.pauseVideo();
            },
          };
        }
      } else if (videoType === "vimeo") {
        const player = new Player(videoWrap, { id: videoId });
        if (player) {
          pl = {
            wrap: videoWrap.parentNode,
            play() {
              player.play();
            },
            pause() {
              player.pause();
            },
          };
        }
      }

      return pl;
    });
  }

  function openModal(modal) {
    if (window.activeModal) {
      closeModal(window.activeModal, true);
    }
    if (!modal.open) {
      document.body.setAttribute("data-modal-open", modal.name);
      modal.open = true;
      window.activeModal = modal;
      cl(modal.modal).addCl("open");
      scLock(modal.modal);
      if (modal.triggers.length) {
        cl(modal.triggers).addCls("active");
      }
      if (modal.videos.length) {
        modal.videos.forEach((v) => {
          if (v.wrap.closest(".swiper-slide-active")) {
            v.play();
          } else if (!v.wrap.closest(".swiper-slide")) {
            v.play();
          }
        });
      }
    }
  }

  function closeModal(modal, beforeOpenOther = false) {
    if (modal.open) {
      if (beforeOpenOther) {
        scUnlock();
      }
      document.body.removeAttribute("data-modal-open");
      modal.open = false;
      window.activeModal = null;
      cl(modal.modal).rmCl("open");
      setTimeout(() => {
        modal.modal.scrollTo(0, 0);
        if (!beforeOpenOther) {
          scUnlock();
        }
      }, 300);
      if (modal.triggers.length) {
        cl(modal.triggers).rmCls("active");
      }
      if (modal.videos.length) {
        modal.videos.forEach((v) => v.pause());
      }
      if (modal.delayed) {
        Cookies.set("modal-closed-" + modal.name, "closed", {
          expires: modal.cookieTime,
        });
      }
      if (modal.callback) {
        modal.callback();
      }
    }
  }

  window.modals = [];
  function setModals(parent, onlyTriggers = false, callback) {
    if (!onlyTriggers) {
      select.all("[data-modal]", parent).forEach((modal) => {
        const videos = iframeVideos(modal);
        const open = modal.classList.contains("open");
        const name = modal.dataset.modal;
        const delayed = modal.dataset.modalDelayed
          ? Number(modal.dataset.modalDelayed)
          : null;
        const cookieTime = modal.dataset.modalCookieTime
          ? Number(modal.dataset.modalDelayed)
          : null;

        const modalEl = {
          name,
          modal,
          videos,
          open,
          delayed,
          cookieTime,
          triggers: [],
          callback,
        };

        const checkId = window.modals.findIndex((m) => m.name === name);
        if (checkId > -1) {
          window.modals.splice(checkId, 1);
        }

        window.modals.push({
          ...modalEl,
          open() {
            openModal(modalEl);
          },
          close() {
            closeModal(modalEl);
          },
        });

        select
          .all(".close, .modal-back, .close-button", modal)
          .forEach((cl) => {
            cl.addEventListener("click", (ev) => {
              ev.preventDefault();
              ev.stopPropagation();
              closeModal(modalEl);
            });
          });

        if (delayed && !Cookies.get("modal-closed-" + modalEl.name)) {
          setTimeout(() => {
            openModal(modalEl);
          }, delayed * 1000);
        }
      });
    }

    select
      .all('[data-modal-target], a[href*="#modal-"]', parent)
      .forEach((trigger) => {
        const target = trigger.dataset.modalTarget
          ? window.modals.find((m) => m.name === trigger.dataset.modalTarget)
          : window.modals.find(
              (m) => m.name === trigger.hash.split("modal-").pop()
            );
        if (target) {
          target.triggers.push(trigger);
          trigger.addEventListener("click", (ev) => {
            ev.preventDefault();
            ev.stopPropagation();
            if (trigger.classList.contains("active")) {
              target.close();
            } else {
              target.open();
            }
          });
        }
      });
  }

  function setBranchSelector(parent) {
    const branchSelector = select(".branch-select", parent);
    if (branchSelector) {
      const selectBranch = select("select", branchSelector);

      branchSelector.addEventListener("submit", (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (selectBranch) {
          barba.go(selectBranch.value);
        }
      });
    }
  }

  function setSearchFields(parent, header = false) {
    const triggers = select.all(".search-trig", parent);

    triggers.forEach((trigger) => {
      const input = select(".input", trigger.nextElementSibling);
      trigger.addEventListener("click", (ev) => {
        ev.preventDefault();
        ev.stopPropagation();

        if (!trigger.classList.contains("active") && input) {
          input.focus();
        }
        cl(trigger).toCl("active");
      });
    });

    const selector =
      (header ? ".header " : ".barba-container ") + ".search-input";
    const searchType = select(selector)
      ? select(selector).dataset.searchType
      : null;
    autocomplete(
      selector,
      {
        hint: false,
        openOnFocus: true,
        // debug: true
      },
      [
        {
          source: (input, callback) => {
            axios(
              "/api/search?query=" +
                input +
                (searchType ? "&type=" + searchType : "")
            ).then(({ data }) => {
              if (data.length) data.forEach((r) => (r._input = input));
              callback(data);
            });
          },
          displayKey: "title",
          debounce: 300,
          templates: {
            suggestion: function (suggestion) {
              const regExp = new RegExp("(" + suggestion._input + ")", "giu");
              const text = suggestion.title.replace(
                regExp,
                '<span class="highlight">$1</span>'
              );
              const extra = suggestion.secondary
                ? ` ${suggestion.secondary}`
                : "";
              let icon = "";
              if (suggestion.icon) {
                icon = suggestion.icon;
              }
              return suggestion.icon
                ? `<span class="sugg-type ${suggestion.type}">${icon}</span>${text}${extra}`
                : text + extra;
            },
            empty: function ({ query }) {
              return `<div class="no-results">No results for: <span class="is-bold">${query}</span></div>`;
            },
          },
        },
      ]
    ).on("autocomplete:selected", function (event, suggestion) {
      barba.go(suggestion.url);
      cl(triggers).toCls("active");
      event.target.value = "";
    });

    select.all(".search-form", parent).forEach((s) => {
      const wrap = select(".algolia-autocomplete", s);
      const input = select(".aa-input", s);

      input.addEventListener("focus", function () {
        cl(wrap).addCl("filled");
        cl(wrap).addCl("focused");
      });
      input.addEventListener("blur", function () {
        cl(wrap).rmCl("focused");
        if (input.value === "") {
          cl(wrap).rmCl("filled");
        }
      });
    });

    if (header) {
      window.addEventListener("click", (ev) => {
        if (!ev.target.closest(".nav-search")) {
          cl(triggers).rmCls("active");
        }
      });
    }
  }

  function loadAllFeedback(parent) {
    const toggle = select(".broker-feedback-toggle", parent);
    const container = select(".broker-feedback", parent);
    const append = select(".broker-feedback-to-load", container);

    if (toggle && container) {
      toggle.addEventListener("click", () => {
        cl(select("span", toggle)).addCl("is-loading");
        var windowURL = window.location.href;
        axios(
          windowURL.replace("#broker-feedback", "") + "?feedbackOnly=true"
        ).then(({ data }) => {
          append.innerHTML = data;
          cl(container).addCl("is-loaded");
        });
      });
    }
  }

  /* payment form window and events */
  function paymentForms(parent) {
    let formPopupName = "formpopup";

    //if we've been returned from windvave - reload the current page and close out the popup.
    var opener = window.opener;
    if (opener && window.name === formPopupName) {
      window.opener.location = window.location;
      window.close();
      return;
    }

    var x = document.createElement("span");
    x.setAttribute("class", "pulsating-circle");

    // add loading to the payment forms - so on devices etc. it's easy to see the form is processing still.
    select.all("form#paymentForm", parent).forEach((form) => {
      form.addEventListener("submit", (e) => {
        //console.log("form: testing");
        const processing = select("button .pulsating-circle", form);
        if (processing) {
          // don't re-submit !
          e.preventDefault();
          //console.log("form: processing");
        } else {
          // add the loading class
          // e.preventDefault();
          //console.log("form: add class");
          cl(select("button", form)).addCl("loading");

          // add the loading circle and disable the button so it can't be clicked again.
          select("button", form).appendChild(x);
          select("button", form).setAttribute("disabled", "disabled");
        }
      });
    });

    //capture form submissions
    select.all("form[data-paymentform]", parent).forEach((form) => {
      //console.log("form: capture submissions");
      form.addEventListener("submit", () => {
        window.open(
          "",
          formPopupName,
          "width=500,height=774,resizeable,scrollbars"
        );
        form.target = formPopupName;

        setTimeout(function () {
          return true;
        }, 4000);
      });
    });
  }

  function toggleCityOrCard(elemets, id) {
    elemets.forEach((c) => {
      const data = c.dataset.mapCity || c.dataset.mapId;
      if (data) {
        if (data === id) {
          cl(c).addCl("active");
        } else {
          cl(c).rmCl("active");
        }
      }
    });
  }

  function setMaps(parent, spoilers = []) {
    //only load google map data on pages with Google Maps
    const mapName = parent.getElementsByClassName("map-wrap");
    if (mapName.length > 0) {
      // console.log('inside: ' + mapName.length);
      const triggers = select.all("[data-map-target]", parent);
      const cardClicks = select.all(".card-click", parent);
      const cities = select.all(".location-city", parent);

      function toggleCity(city, trig = false) {
        cl(triggers).rmCls("active");
        if (trig) {
          cl(trig).addCl("active");
        }

        //cities.dataset.mapCity
        var cardCount = document.querySelectorAll(
          '.location-city[data-map-city="' + city + '"] .location-card'
        ).length;
        app.maps.locationClick(city, "locations-map");

        toggleCityOrCard(cities, city);
        cl(cardClicks).rmCls("active");
      }

      app.maps = new maps(
        parent,
        (city, id) => {
          spoilers.forEach((s) => {
            const activeTrigger = select(
              '[data-map-target="' + city + '"]',
              s.content
            );

            if (activeTrigger) {
              cl(activeTrigger).addCl("active");
              s.open();
              triggers.forEach((t) => {
                if (city !== t.dataset.mapTarget) {
                  cl(t).rmCl("active");
                }
              });
            } else {
              s.close();
            }

            toggleCityOrCard(cities, city);
            toggleCityOrCard(cardClicks, id);
          });
        },
        () => {
          cl(triggers).rmCls("active");
          cl(cardClicks).rmCls("active");
          cl(cities).rmCls("active");
        },
        () => {
          select.all(".locations-section", parent).forEach((section) => {
            if (section.dataset.branch) {
              toggleCity(section.dataset.branch);
              spoilers.forEach((s) => {
                const activeTrigger = select(
                  '[data-map-target="' + section.dataset.branch + '"]',
                  s.content
                );

                if (activeTrigger) {
                  cl(activeTrigger).addCl("active");
                  s.open();
                }
              });
            }
          });
        }
      );
      triggers.forEach((trig) => {
        const city = trig.dataset.mapTarget;
        if (city) {
          trig.addEventListener("click", (ev) => {
            ev.preventDefault();
            ev.stopPropagation();

            toggleCity(city, trig);
          });
        }
      });

      // cardClicks.forEach(click => {
      //   const id = click.dataset.mapId
      //   if (id) {
      //     click.addEventListener('click', ev => {
      //       ev.preventDefault()
      //       ev.stopPropagation()
      //       cl(cardClicks).rmCls('active')
      //       cl(click).addCl('active')
      //       app.maps.locationClick(id, 'locations-map', 17)
      //     })
      //   }
      // })

      select.all("[data-reset-map]").forEach((reset) => {
        reset.addEventListener("click", () => {
          app.maps.reset(reset.dataset.resetMap);
          spoilers.forEach((s) => s.close());
          cl(triggers).rmCls("active");
          cl(cardClicks).rmCls("active");
          cl(cities).rmCls("active");
        });
      });
    }
  }

  //campaign maps
  function setMapsXmas(parent) {
    const element = document.querySelector(".xmas-container");

    if (element) {
      app.mapsXmas = new mapsXmas(parent);
    }
  }

  function claimsSelect(parent) {
    var selectList = document.getElementById("claims-list");
    var selectEmail = document.getElementById("claims-email");
    if (selectList) {
      selectList.addEventListener("change", function () {
        selectEmail.innerHTML =
          '<a href="mailto:' +
          selectList.value +
          '">' +
          selectList.value +
          "</a>";
      });
    }
  }

  function _do_formSubmit(form, event, formHandle) {
    form.addEventListener(event, (e) => {
      e.preventDefault();
      if (e.details && e.detail.nextPageId) {
        return;
      }
      let toPush = {
        event: "formSubmission",
        formType: formHandle,
        page: window.location.pathname,
      };
      window.dataLayer = window.dataLayer || [];
      dataLayer.push(toPush);
    });
  }

  function gtmFormSubmissions(selector) {
    let forms = document.querySelectorAll('form[id^="fui-"]');
    forms.forEach((f) => {
      var config = JSON.parse(f.getAttribute("data-fui-form"));
      _do_formSubmit(f, "onAfterFormieSubmit", config.formHandle);
    });
  }

  function iframeResizer(parent) {
    select.all('.resize-iframe', parent).forEach(iframe => {
      iframeResize({ heightCalculationMethod: 'max' }, iframe)
    })
  }

  app.lazyload = null;
  function setLazy(parent) {
    if (app.lazyload) app.lazyload.destroy();
    app.lazyload = new LazyLoad({
      elements_selector: "[data-src]"
    });
  }

  //Insurance Solutions Mega Menu - Select the active button and tab
  function megaMenu() {
    const megaMenu = select(".mega-menu");
    const megaMenuActiveSlug = select("[data-active-slug]").dataset.activeSlug;
    const megaMenuItems = select.all(".mega-menu-buttons div span");
    const megaMenuTabs = select.all(".tabs .tab", megaMenu);
    
    //check if the active slug is set (homepage fix)
    const activeSlug = megaMenuActiveSlug ? select("[data-slug="+megaMenuActiveSlug+"]", megaMenu) : false;

    megaMenuItems.forEach((item) => {
      const itemSlug = item.dataset.slug;
      if(activeSlug) {
        if (itemSlug === megaMenuActiveSlug) {
          cl(item).addCl("active");
          cl(megaMenuTabs).rmCl("active");
          cl("#"+item.dataset.tab).addCl("active");
        }else{
          cl(item).rmCl("active");
        }
      }
    });
  }

  

  function toLoad(parent) {
    select.all(".to-load").forEach((el) => {
      setTimeout(() => {
        cl(el).addCl("loaded");
      }, 400);
    });
  }

  function outBarba() {
    app.nav = new nav();
  }

  app.videRes = null;
  function onBarba(parent) {
    cl("body").rmCl("is-empty");
    //activeNav();
    accordionBodyBlock();
    tabsBlock();
    // fixes the inputs from not running on blank page campaign templates: /campaigns/enquiry-form/
    var templateBlank = document.getElementsByClassName("page-template-blank").length;
    if( templateBlank ){
      inputs();
    }
    
    if (parent) {
      megaMenu();
      setBranchSelector(parent);
      setHoverElements(parent);
      swipers(parent);
      setSmooth(parent);
      setLazy(parent);
      paymentForms(parent);
      youtubeVideoModal();
      initSliderPageSvelteApp();
      initSummerSearcher(parent);
      lottiePlayer(parent);
      inputs(parent);
      setModals(parent);
      setTabs(parent);
      setSearchFields(parent);
      toLoad(parent);
      loadAllFeedback(parent);
      iframeResizer(parent);
      claimsSelect(parent);
      gtmFormSubmissions(parent);
      selectSearch(parent);
      app.spoilers = new Spoilers(parent);
      setMaps(parent, app.spoilers.spoilers);
      setMapsXmas(parent);
      app.videRes = new videoResize(".has-cover-video");
      app.scroll = new scrollAnimatron(
        [
          {
            el: ".an1",
            offset: 200,
            classAdd: "fade-in-up-small",
          },
          {
            el: ".an2",
            offset: 200,
            classAdd: "fade-in-up",
          },
          {
            el: ".an3",
            offset: 0,
            classAdd: "fade-in-up-cover",
          },
          {
            el: ".an4",
            offset: 0,
            classAdd: "fade-in",
          },
          {
            el: ".an-r",
            offset: 0,
            classAdd: "fade-in-right",
          },
          {
            el: ".an-l",
            offset: 0,
            classAdd: "fade-in-left",
          },
        ],
        parent
      );

      const js = select.all(".barba-wrapper script", parent);
      if (js != null) {
        js.forEach((item) => {
          if (item.innerHTML.indexOf("enkoder") !== -1) {
            eval(item.innerHTML);
          }
        });
      }
    }
    

  }

  doc.addEventListener("DOMContentLoaded", function () {
    outBarba();
    cl(".barba-container").rmCl("is-hidden");

    document.addEventListener("onFormieInit", (e) => {
      // Fetch the Form Factory once it's been loaded
      let Formie = e.detail.formie;

      let forms = document.querySelectorAll('form[id^="formie-form-"]');

      forms.forEach((f) => {
        if (
          forms.querySelector &&
          forms.querySelector(".fui-type-file-upload")
        ) {
          let form = f;
        }

        // **Steps
        // add progress bar to submit button
        // start upload

        // var config = JSON.parse(f.getAttribute('data-config'));
        // _do_formSubmit(f,'onAfterFormieSubmit',config.formHandle);
      });
    });

    win.addEventListener(
      "scroll",
      throttle(function () {
        if (app.nav) app.nav.scroll();
        if (app.scroll) app.scroll.scroll();
      }, 50)
    );

    // win.addEventListener('resize', throttle(function () {
    //   window.modals.forEach(m => (m.close()))
    // }, 300));

    barba.init({
      timeout: 5000,
      prefetchIgnore: true,
      prevent: ({ el, href }) => {
        return true //effectively disabling barba on all links.
      },
      transitions: [
        {
          from: {
            custom() {
              return window.openModal === false;
            },
          },
          name: "transition",
          leave({ current }) {
            cl(current.container).addCl("is-hidden");
            cl(".header").addCl("reset");
            const done = this.async();
            setTimeout(done, 400);
          },
        },
      ],
    });

    barba.hooks.beforeEnter(() => {
      window.scrollTo(0, 0);
    });

    barba.hooks.enter(({ next }) => {
      window.modals.forEach((m) => m.close());
      app.navSpoilers.closeAll();
      cl(next.container).rmCl("is-hidden");
      cl(".header").rmCl("reset");
    });

    barba.hooks.afterEnter(({ next }) => {
      onBarba(next.container);
      select.all("video", next.container).forEach((v) => {
        v.play();
      });
    });

    barba.hooks.after(({ next }) => {
      youtubeVideoModal();
      initLandingPageSvelteApp();
      initSliderPageSvelteApp();
      initSummerSearcher();
      addFormieScript(next.container);
      // for GTAG or GA
      // window.dataLayer.push({
      //   "event": "pageview",
      //   "page": {
      //     "path": window.location.pathname,
      //     "title": document.title
      //   }
      // });
    });
  });
})(document, window);
